// extracted by mini-css-extract-plugin
module.exports = {"ErrorContainer":"ErrorFallBack_ErrorContainer__nPcvW"};